<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <!-- <template slot="headAction">
        <a-button style="margin-left:10px" type="primary" @click="updatePassWord">重置密码</a-button>
      </template>-->
    </data-table>
    <a-modal
      centered
      :maskClosable="false"
      title="编辑价格代码"
      v-model="visible.groupUpdateModal"
      width="40%"
      @ok="handleOk"
    >
      <div style="text-align: left;">
        <p style="margin-bottom:5px">
          <label style="display:inline-block;text-align:right;width: 80px;"
            >价格代码：</label
          ><a-select
            mode="multiple"
            style="width: 70%;"
            v-model="priceCodeIds"
            allowClear
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="(item, index) in priceCodeSelect"
              :key="index"
              :value="item.Id"
              >{{ item.Text }}</a-select-option
            >
          </a-select>
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "channelManage_channel",
  components: { DataTable },
  props: {},
  data() {
    return {
      visible: {
        groupUpdateModal: false
      },
      editInfo: null,
      priceCodeIds: "",
      priceCodeSelect: []
    };
  },
  created() {
    this.option = {
      form: {
        colnum: 1,
        width: 600,
        title: "渠道",
        add: {
          submitApi: "Channel_Add",
          onOpenAfter: () => {
            this.setFieldsDisabled(false);
            return { ValidStatus: 1, Sort: 0 };
          }
        },
        edit: {
          infoApi: "Channel_Info",
          submitApi: "Channel_Edit",
          onOpenBefore: () => {
            this.setFieldsDisabled(true);
          }
        },
        del: { submitApi: "Channel_Del" },
        content: [
          {
            label: "编码",
            name: "Code",
            option: {
              rules: [
                { required: true, message: "请填写编码！" },
                {
                  validator: (rule, value, callback) => {
                    if (value.length > 16) {
                      callback(new Error("不能超过16个字符!"));
                    } else {
                      callback();
                    }
                  }
                }
              ]
            }
          },
          {
            label: "名称",
            name: "Name",
            // props: {
            //   disabled: true
            // },
            option: {
              rules: [
                { required: true, message: "请填写名称！" },
                {
                  validator: (rule, value, callback) => {
                    if (value.length > 32) {
                      callback(new Error("不能超过32个字符!"));
                    } else {
                      callback();
                    }
                  }
                }
              ]
            }
          },

          {
            label: "排序",
            name: "Sort",
            type: "number"
          },
          {
            label: "价类",
            type: "multipleSelect",
            name: "PriceCodeIds",
            option: {
              rules: [{ required: true, message: "请选择价类！" }]
            },
            api: "Common_GetSelect",
            param: { types: "PriceCode" },
            dataField: "Data.PriceCode"
          },
          {
            label: "OTA客户",
            name: "OTACustomerId",
            type: "select",
            api: "Common_GetSelect", //请求接口api
            param: { Types: "customer" }, //请求参数
            dataField: "Data.customer", //请求可选项返回的数据字段
            props: {
              showSearch: true,
              optionFilterProp: "children",
              allowClear: false
            }
          },
          {
            label: "OTA业务员",
            name: "OTASalesmanId",
            type: "select",
            api: "Common_GetSelect", //请求接口api
            param: { Types: "Salesman" }, //请求参数
            dataField: "Data.Salesman" //请求可选项返回的数据字段
          },
          {
            label: "状态",
            name: "ValidStatus",
            placeholder: "请选择",
            option: {
              rules: [{ required: true, message: "请选择状态！" }]
            },
            type: "select",
            valueField: "value",
            textField: "text",
            data: [
              {
                value: 0,
                text: "禁用"
              },
              {
                value: 1,
                text: "启用"
              }
            ]
          },
          {
            label: "AppKey",
            name: "AppKey"
            // option: {
            //   rules: [{ required: true, message: "请填写编码！" }]
            // }
          }
        ]
      },
      grid: {
        api: "Channel_List",
        columns: [
          {
            title: "序号",
            width: "50px",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "编码",
            dataIndex: "Code",
            width: "100px"
          },
          {
            title: "名称",
            dataIndex: "Name",
            width: "200px"
          },
          {
            title: "排序",
            dataIndex: "Sort",
            width: "60px"
          },
          {
            title: "价类",
            dataIndex: "PriceCodeNames",
            width: "100px"
          },
          {
            title: "渠道类别",
            dataIndex: "IsGroup",
            width: "100px",
            customRender: text => {
              if (text) {
                return "集团";
              } else {
                return "门店";
              }
            }
          },
          // {
          //   title: "属性",
          //   dataIndex: "ChannelAttribute",
          //   customRender: (text, record, index) => {
          //     if (text) {
          //       return <a-badge status="success" text="内置渠道" />;
          //     } else {
          //       return <a-badge status="error" text="自定义渠道" />;
          //     }
          //   }
          // },
          {
            title: "OTA客户",
            dataIndex: "OTACustomerName"
          },
          {
            title: "OTA业务员",
            dataIndex: "OTASalesmanName",
            width: "150px"
          },
          {
            title: "AppKey",
            dataIndex: "AppKey",
            width: "180px"
          },
          {
            title: "状态",
            dataIndex: "ValidStatus",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="启用" />;
              } else {
                return <a-badge status="error" text="禁用" />;
              }
            },
            width: "100px"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "130px",
            key: "action",
            customRender: (text, record) => {
              const edit = {
                click: () => {
                  if (record.IsGroup) {
                    this.editInfo = record;
                    this.priceCodeIds = record.PriceCodeIds;
                    this.Sort = record.Sort;
                    this.visible.groupUpdateModal = true;
                  } else {
                    this.edit(record.Id);
                  }
                }
              };
              if (record.ChannelAttribute || record.IsGroup) {
                return (
                  <div>
                    <a-button size="small" type="link" {...{ on: edit }}>
                      编辑
                    </a-button>
                  </div>
                );
              } else {
                const del = {
                  confirm: () => {
                    this.del(record.Id);
                  }
                };
                return (
                  <div>
                    <a-button size="small" type="link" {...{ on: edit }}>
                      编辑
                    </a-button>{" "}
                    |{" "}
                    <a-popconfirm
                      title="你确认删除吗？"
                      {...{ on: { ...del } }}
                      okText="确定"
                      cancelText="取消"
                    >
                      <a-button size="small" type="link">
                        删除{" "}
                      </a-button>
                    </a-popconfirm>
                  </div>
                );
              }
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.$post("Common_GetSelect", { Types: "pricecode" }).then(res => {
      this.priceCodeSelect = res.Data.pricecode;
    });
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    setFieldsDisabled(value) {
      const fields = ["Code", "AppKey"];
      const content = cloneDeep(this.option.form.content);
      const newContent = content.map(item => {
        if (fields.indexOf(item.name) > -1) {
          if (item.props && typeof item.props === "object") {
            item.props.disabled = value;
          } else {
            item.props = {
              disabled: value
            };
          }
        }
        return item;
      });
      this.$refs.dataTable.updateFormContent("", "", newContent);
    },
    edit(Id) {
      this.$refs.dataTable.edit(Id);
    },
    del(Id) {
      this.$refs.dataTable.del({ Id: Id });
    },
    handleOk() {
      const _this = this;
      if (!this.editInfo) this.$message.info("编辑失败，请重试！");
      this.editInfo.PriceCodeIds = this.priceCodeIds;
      this.editInfo.Sort = this.Sort;
      this.$post("Channel_Edit", this.editInfo).then(() => {
        _this.visible.groupUpdateModal = false;
        _this.$message.info("编辑成功！");
        // _this.$refs.dataTable.headSearch();
        _this.$refs.dataTable.$refs.dataGrid.reload();
      });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped></style>
